<template>
  <div class="md-layout header-election-w" role="banner">
    <div class="md-layout-item md-size-100" id="identity-main">
      <md-card
        class="custom bgcolor"
        v-if="!$store.state.electionEvent && this.$store.state.eventNumber > 1"
      >
        <div class="md-title no-title" role="heading" aria-level="1">
          {{ $t("election-event-select") }}
        </div>
      </md-card>
      <md-card class="custom bgcolor" v-if="$store.state.electionEvent">
        <div class="md-title " role="heading" aria-level="1">
          <span class="screenreader"
            >{{ $t("election-event.screen-reader.title") }}:
          </span>
          {{
            $store.state.electionEvent.ElectionEvent.EventIdentifier.EventName
          }}
        </div>
        <span class="screenreader">{{
          $t("election-event.screen-reader.from-date")
        }}</span>
        <span
          class="md-caption"
          v-if="
            $store.state.electionEvent.ElectionEvent.EventDate !== null &&
              $store.state.electionEvent.ElectionEvent.EventDate.Start
          "
        >
          {{ $store.state.electionEvent.ElectionEvent.EventDate.Start }}
        </span>
        <span class="screenreader">{{
          $t("election-event.screen-reader.to-date")
        }}</span>
        <span
          class="md-caption"
          v-if="
            $store.state.electionEvent.ElectionEvent.EventDate !== null &&
              $store.state.electionEvent.ElectionEvent.EventDate.End
          "
        >
          -
          {{ $store.state.electionEvent.ElectionEvent.EventDate.End }}
        </span>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data: function() {
    return {
      electionEvent: null
    };
  },
  props: [],
  methods: {},
  components: {}
};
</script>
<style scoped>
.resized {
  width: 50%;
  max-width: 200px;
}
.custom {
  margin: 5px;
  padding: 5px;
}
.bgcolor {
  background-color: #dedddb !important;
}
.md-card {
  box-shadow: none !important;
  background: transparent !important;
  border-bottom: 1px solid #333 !important;
  border-radius: 0 !important;
}
.md-card .md-title {
  font-weight: bold !important;
}

.md-tabs-content {
  height: auto !important;
}

.md-caption {
  color: rgba(0, 0, 0, 0.87) !important;
}

.no-title {
  padding: 5px 0;
}
</style>
